package ru.villawonka.app.presentation.sharedviews.postList.compose

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.common.extensions.isScrollingUp
import ru.villawonka.app.presentation.design.components.filledButtonPrimaryBackgroundEnabled
import ru.villawonka.app.presentation.design.components.filledButtonPrimaryContentEnabled
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.model.PostUIModel
import ru.villawonka.app.presentation.model.getPostType
import ru.villawonka.app.presentation.sharedviews.postList.compose.view.PostItemLayout
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_arrow_up_24

@Composable
fun PostListRootLayout(
    topPadding: Dp,
    bottomPadding: Dp,
    title: String,
    listState: LazyListState,
    posts: List<PostUIModel>,
    callbacks: PostListCallbacks,
) {
    val isScrollingUp = listState.isScrollingUp()
    val isScrollToUpButtonVisible by derivedStateOf {
        listState.firstVisibleItemIndex >= 2 && isScrollingUp
    }

    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        LazyColumn(
            state = listState,
            contentPadding = PaddingValues(
                top = topPadding + 24.dp,
                bottom = 64.dp
            ),
        ) {
            item(key = title) {
                Text(
                    text = title,
                    style = AppTextStyles.titleMediumBold,
                    color = MaterialTheme.colors.onSurfacePrimary,
                    modifier = Modifier.padding(horizontal = 16.dp)
                )
                AppSpacer(8.dp)
            }
            items(
                items = posts.filter { it.hidden.not() },
                contentType = { it.getPostType() },
                key = { it.id },
            ) { post ->
                PostItemLayout(
                    post = post,
                    maxWidth = maxWidth.value,
                    callbacks = callbacks,
                    listState = listState,
                )
                AppSpacer(8.dp)
            }
        }

        AnimatedVisibility(
            visible = isScrollToUpButtonVisible,
            enter = slideInVertically(
                initialOffsetY = { fullHeight -> fullHeight },
                animationSpec = tween(durationMillis = 300)
            ),
            exit = slideOutVertically(
                targetOffsetY = { fullHeight -> fullHeight },
                animationSpec = tween(durationMillis = 300)
            ),
            modifier = Modifier.align(Alignment.BottomEnd)
        ) {
            FloatingActionButton(
                onClick = callbacks.onScrollToUpButtonClick,
                backgroundColor = MaterialTheme.colors.filledButtonPrimaryBackgroundEnabled,
                contentColor = MaterialTheme.colors.filledButtonPrimaryContentEnabled,
                modifier = Modifier.padding(
                    end = 24.dp,
                    bottom = bottomPadding + 24.dp
                ),
            ) {
                Icon(
                    painter = painterResource(Res.drawable.ic_arrow_up_24),
                    contentDescription = null,
                )
            }
        }
    }
}